import { Application } from "@hotwired/stimulus";
import HwComboboxController from "@josefarias/hotwire_combobox";

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

// Set by the system specs' Cuprite driver. Stimulus catches errors thrown by
// controllers, so the browser never reports them as uncaught and the specs
// can't see them. Rethrowing on a fresh task leaves Stimulus's isolation intact.
if (window.STIMULUS_RETHROW_ERRORS) {
  const handleError = application.handleError.bind(application);

  application.handleError = (error, message, detail) => {
    handleError(error, message, detail);
    setTimeout(() => {
      throw error;
    });
  };
}

// Import and register any external controllers here. Otherwise, any manual
// entries to the manifest will get yeeted with rails stimulus:manifest:update.
application.register("hw-combobox", HwComboboxController);

export { application };
